exports = module.exports = require("./node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\ntable[data-v-67bf712e] {\n  width: auto;\n  margin: 0 auto;\n}\ntable tr[data-v-67bf712e] {\n  border: none;\n}\ntable tr.strong[data-v-67bf712e] {\n  font-weight: bold;\n}\ntable td[data-v-67bf712e] {\n  padding: 0px 4px;\n  text-align: left;\n}\ntable td[align=right][data-v-67bf712e] {\n  text-align: right;\n}\n", ""]);

// exports
